<div class="pos-relative" class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="sem-calls">
		<div class="calls-title">
			<h2>{{ sectiontitle }}</h2>
		</div>
		<ul class="calls-summary">
			<li *ngFor="let legendItem of legends">
				<h2
					*ngIf="
						(metricsData[legendItem.value] === null || metricsData[legendItem.value] === undefined) &&
						legendItem.displayName
					"
				>
					- -
				</h2>
				<span *ngIf="metricsData[legendItem.value] !== null && metricsData[legendItem.value] !== undefined">
					<h2 *ngIf="!legendItem.isFloat && !legendItem.isTime">
						{{ metricsData[legendItem.value] | number }}
					</h2>
					<h2 *ngIf="legendItem.isFloat">
						{{ metricsData[legendItem.value] | number: '1.0-2' }}
					</h2>
					<h2 *ngIf="legendItem.isTime">
						{{ metricsData[legendItem.value] }}
					</h2>
				</span>
				<label class="stats-label">{{ legendItem.displayName }}</label>
			</li>
		</ul>
		<div class="graph-filter">
			<div class="filterLabel">
				<h4>Filter calls</h4>
			</div>
			<div class="all-filter-options" [ngClass]="{ 'answered-inactive': graphFilterDisabled }">
				<div class="single-filter-option" *ngFor="let graphFilterOption of graphFilterOptions; let i = index">
					<label class="container">
						<input
							type="radio"
							class="radiobutton"
							name="graphFilterOption"
							value="{{ i }}"
							[(ngModel)]="selectedValue"
							(change)="filterChange(selectedValue)"
							[disabled]="graphFilterDisabled"
						/>
						<!--		when filtering is disabled or enabled but not selected-->
						<svg
							class="radiobutton-circle radiobutton-circle-disabled"
							[ngClass]="[
								'radio-option-text',
								graphFilterDisabled
									? 'radiobutton-circle-disabled'
									: !graphFilterDisabled && selectedValue != i
									? 'radiobutton-circle-enabled'
									: !graphFilterDisabled && selectedValue == i
									? 'hide-radio'
									: ''
							]"
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 18 18"
						>
							<path
								d="M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 3C5.686 3 3 5.686 3 9s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
							/>
						</svg>
						<!--		when filtering is enabled and selected-->
						<svg
							*ngIf="!graphFilterDisabled && selectedValue == i"
							class="radiobutton-circle-selected"
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 18 18"
						>
							<path
								d="M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 3C5.686 3 3 5.686 3 9s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 2c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
							/>
						</svg>
						<!--		Radio button Labels -->
						<span class="filter-text" [ngClass]="[graphFilterDisabled ? 'answered-inactive' : '']"
							>{{ graphFilterOption.name }}
						</span>
					</label>
				</div>
			</div>
		</div>

		<div class="analytics-portlet-content">
			<div class="calls-graph-area">
				<div *ngIf="!hasData" class="chart-area _u-text-center vertical-align-center">
					<h3>No Data Available</h3>
				</div>
				<div *ngIf="hasData && allGraphData.length" class="scatter-chart">
					<app-generic-chart
						class="chart-area"
						[configuration]="scatterplotConfiguration"
						[data]="graphData"
						[colorPalette]="colorPaletteObj"
					></app-generic-chart>
				</div>
				<div class="chart-summary-area">
					<div class="summary-heading">Chart Summary</div>
					<div class="calls-data">
						<ul class="chart-summary">
							<li class="summary-item">
								<h2
									class="stats-primary"
									*ngIf="chartMetricData.answeredCalls === null || chartMetricData.answeredCalls === undefined"
								>
									- -
								</h2>
								<h2 class="stats-primary">{{ chartMetricData.answeredCalls | number }}</h2>
								<label class="stats-label">answered calls</label>
							</li>
							<li class="summary-item">
								<h2
									class="stats-primary"
									*ngIf="chartMetricData.avgDuration === null || chartMetricData.avgDuration === undefined"
								>
									- -
								</h2>
								<h2 class="stats-primary">{{ chartMetricData.avgDuration }}</h2>
								<label class="stats-label">Avg. Duration (HH:MM:SS)</label>
							</li>
							<li class="summary-item">
								<h2
									class="stats-secondary"
									*ngIf="chartMetricData.missedCalls === null || chartMetricData.missedCalls === undefined"
								>
									- -
								</h2>
								<h2 class="stats-secondary">{{ chartMetricData.missedCalls | number }}</h2>
								<label class="stats-label">missed calls</label>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
